import { Injectable } from '@angular/core';
import { HttpClientService } from '../httpClient/httpclient.service';
import { Observable } from 'rxjs/Observable';
import { Indicator } from '../../models/dashboard.model';

@Injectable()
export class DashboardService {

  public baseUrl = '/koncentro-analytics';

  constructor(
    private http: HttpClientService
  ) { }

  //TODO SERVICE TO REMOVE. DO REFACTOR (NOTE BY ERNESTO)

  getIndicator(nameIndicator: string): Observable<Array<Indicator>> {
    return this.http.get(this.baseUrl + '/analytics/indicators/getIndicator/' + nameIndicator);
  }

  /**
   * Restituisce, in param_code, l'ultima versione rilasciata della UI
   */
  getUIVersion() {
    return this.http.get('koncentro-loyalty/params/getParam/UI.VERSION');
  }

}



// WEBPACK FOOTER //
// ./src/app/services/dashboard/dashboard-service.service.ts